import validate from "/var/www/rare-database/node_modules/.pnpm/nuxt@3.20.2_@parcel+watcher@2.5.1_@types+node@25.0.1_@vue+compiler-sfc@3.5.25_cac@6.7.1_3ab5a58280573d597f608d1d6f347996/node_modules/nuxt/dist/pages/runtime/validate.js";
import _01_45equipment_45global from "/var/www/rare-database/middleware/01.equipment.global.ts";
import _02_45language_45global from "/var/www/rare-database/middleware/02.language.global.ts";
import _03_45mode_45global from "/var/www/rare-database/middleware/03.mode.global.ts";
import _04_45auth_45global from "/var/www/rare-database/middleware/04.auth.global.ts";
import _05_45access_45global from "/var/www/rare-database/middleware/05.access.global.ts";
import manifest_45route_45rule from "/var/www/rare-database/node_modules/.pnpm/nuxt@3.20.2_@parcel+watcher@2.5.1_@types+node@25.0.1_@vue+compiler-sfc@3.5.25_cac@6.7.1_3ab5a58280573d597f608d1d6f347996/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  _01_45equipment_45global,
  _02_45language_45global,
  _03_45mode_45global,
  _04_45auth_45global,
  _05_45access_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}